import {
  useState,
  useEffect,
  useContext,
  JSXElementConstructor,
  Key,
  ReactElement,
  ReactNode,
  ReactPortal,
} from "react";
//import { APICall } from "../../Helpers/APICalls/APICalls";
import { useLocation } from "react-router-dom";
import {
  getFormConfigDetails,
  getFormValues,
  executeAction,
  getCascadeFieldOptions,
  UploadFile,
} from "../../Helpers/APIEndpoints/Endpoints";
import { LoaderContext } from "../../Helpers/Context/Context";

import { Collapse, message, Row, Tabs } from "antd";
import DynamicFormCase from "../DynamicFieldRenderer/DynamicFieldRenderer";
import "./DynamicForm.css";
//import { FormResponse } from "../../Pages/Masters/Response";

//import Title from "antd/es/typography/Title";
import { API } from "../../Axios/Axios";
import dayjs from "dayjs";
import { useAuthStore } from "../../AuthStore/AuthStore";
import { useActionHandler } from "../ActionHandlerContext";
import Title from "antd/es/typography/Title";
//import { DocumentViewStaticJSON } from "../../Helpers/StaticJSON/DocumentView";
// import { useNavigation } from "@react-navigation/native";

// interface DynamicFormProps {
//   form: any;
//   props: any;
// }

const { Panel } = Collapse;
//const { TabPane } = Tabs;
const DynamicFormComponent = ({ ...props }: any) => {
  const location = useLocation();
  const { state } = location || {};
  const [formData, setFormData] = useState<any>(null);
  const [form] = useState<any>(props?.form);
  const [activeTab] = useState<any>(props?.activeTab || null);
  const [isReset, setIsReset] = useState(false);
  // const [actionType, setActionType] = useState(
  //   state?.actionType || props?.actionType || null
  // );
  const [actionType] = useState(state?.actionType || props?.actionType || null);
  const [formSections, setFormSections] = useState(props?.formSections || null);
  //const [activeKey, setActiveKey] = useState<any>();
  const [RId] = useState(state?.RId || props?.RId);
  const [interfaceId, setInterfaceId] = useState<Number>(
    state?.id || props?.id || 0
  );
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [gridData, setGridData] = useState<Record<string, any>>([]);
  //const navigate = useNavigate();
  const [mode] = useState(state?.Mode || props?.Mode);
  const [fetchFormData, setFetchFormData] = useState<any>();

  const [buttonLoadings, setButtonLoadings] = useState<Record<string, boolean>>(
    {}
  );
  const { interfaceActionHandler } = useActionHandler();
  const { userId, currentRoleId, currentFinancialYearId } = useAuthStore();

  let formConfig: any = null;

  // useEffect(() => {
  //   if (!state?.id && !state?.actionType && !state?.RId) {
  //     return;
  //   }
  //   setInterfaceId(state.id);
  //   setRId(RId);
  //   setActionType(state?.actionType);
  // }, [state]);

  // useEffect(() => {
  //   if (interfaceId) getFormConfig();
  // }, [interfaceId]);

  useEffect(() => {
    if (
      !state?.id &&
      !props?.id &&
      !state?.actionType &&
      !props?.actionType &&
      !state?.RId &&
      !props?.RId
    ) {
      return;
    }

    setInterfaceId(state?.id || props?.id || 0);
    // setRId(RId);

    // setActionType(state?.actionType || props?.actionType);
  }, [state]);

  // useEffect(() => {
  //   if (interfaceId) getFormConfig();
  // }, [interfaceId]);

  let getcurrentTabData = async () => {
    return new Promise((resolve, reject) => {
      API.post(getFormConfigDetails, {
        InterfaceId: interfaceId,
        TabId: parseInt(activeTab) || 0,
        Mode: "Edit",
      })
        .then((response) => {
          if (response && !response.status) {
            throw new Error("Failed to fetch data");
          }
          return response;
        })
        .then((data) => resolve(data))
        .catch((error) => {
          console.error("Error fetching tab data:", error);
          reject(error);
        });
    });
  };

  useEffect(() => {
    if (activeTab) {
      let activeDataSectionsExists =
        formData &&
        formData.data &&
        formData?.data[parseInt(activeTab)]?.section?.length > 0
          ? true
          : false;
      if (!activeDataSectionsExists) {
        getcurrentTabData().then((formConfigResponse: any) => {
          if (
            formConfigResponse.data &&
            formConfigResponse.data?.data?.length > 0
          ) {
            formConfig = formConfigResponse.data;

            let dynamicFormData = formData;
            if (dynamicFormData) {
              for (
                let index = 0;
                index < dynamicFormData?.data?.length;
                index++
              ) {
                let data = dynamicFormData.data;
                if (!dynamicFormData.data[index]) {
                  dynamicFormData.data[index] = {}; // Initialize it as an empty object
                }

                if (
                  formConfig.data.some(
                    (x: { tabId: { toString: () => any } }) =>
                      x.tabId.toString() === data[index]?.TabId?.toString()
                  )
                ) {
                  dynamicFormData.data[index].section = formConfig.data.find(
                    (x: { tabId: { toString: () => any } }) =>
                      x.tabId.toString() === data[index]?.TabId?.toString()
                  )?.section;
                }
              }
            } else {
              dynamicFormData = formConfigResponse.data;
            }

            //setFormData((prevData: any) => ({ ...prevData, [activeTab]: dynamicFormData as string }));
            setFormSections(dynamicFormData.data[0].section);
          }

          if (mode === "Edit") {
            debugger;

            // const FetchFormData = async () => {
            //   const FetchFormValues = await API.post(getFormValues, {
            //     InterfaceId: interfaceId,
            //     RId: RId,
            //     Mode: "Edit",
            //     ActionType: "Fetch",
            //     FieldIds: "",
            //     FormData: `{"RId":${RId}}`
            //   });
            //   return FetchFormValues.data;
            // };

            let formValues = FetchFormDataAPI();

            // const mapFormValues = (apiOne: any, apiTwo: any) => {
            //   const formValues: Record<string, any> = {}; // Explicitly define the type

            //   apiOne.forEach((section: any) => {
            //     section.content.forEach((field: any) => {
            //       // Find the matching object in apiTwo based on placeHolderId
            //       const matchedEntry = apiTwo.find(
            //         (entry: any) => entry.placeHolderId === field.placeHolderId
            //       );

            //       if (
            //         matchedEntry &&
            //         matchedEntry.data[field.name] !== undefined
            //       ) {
            //         const matchedValue = matchedEntry.data[field.name];

            //         if (field.typename === "Checkbox") {
            //           // Convert checkbox values to boolean
            //           formValues[field.name] = matchedValue === "1";
            //           // formValues[field.name] = (matchedValue?.toString() === "1").toString();
            //         } else if (field.typename === "Select") {
            //           // Map the state dropdown using label instead of value
            //           const selectedOption = field.fieldOptions?.find(
            //             (option: any) =>
            //               option.value.toString() === matchedValue.toString()
            //           );

            //           formValues[field.name] = selectedOption
            //             ? selectedOption.value.toString()
            //             : matchedValue.toString();
            //         }  else  if (field.typename === "selectMulti"){

            //           formValues[field.name] = matchedValue
            //           .toString()
            //           .split(",")
            //           .map((val:any) => val.trim());
            //         } else {
            //           formValues[field.name] = matchedValue;
            //         }
            //       }
            //     });
            //   });

            //   return formValues;
            // };

            // // Get mapped values
            // const mappedValues = mapFormValues(formConfig, formValues);

            // // Set form fields in Ant Design
            // form.setFieldsValue(mappedValues);
            //   form.setFieldsValue(item['Data']);

            const mapFormCascadeOptions = async (apiOne: any, apiTwo: any) => {
              for (const section of apiOne.data) {
                for (const field of section.content) {
                  // Find the matching object in apiTwo based on placeHolderId
                  const matchedEntry = apiTwo.find(
                    (entry: any) => entry.placeHolderId === field.placeHolderId
                  );

                  if (
                    matchedEntry &&
                    matchedEntry.data[field.name] !== undefined
                  ) {
                    if (field.lazyload) {
                      let fieldOptions = await getCascadeOptions(
                        field,
                        matchedEntry.data
                      );

                      if (fieldOptions.length > 0) {
                        field.fieldOptions = fieldOptions;
                      }
                    }
                  }
                }
              }
            };

            const updateFormValues = async () => {
              await mapFormCascadeOptions(formConfig.data.data, formValues); // Ensure all async calls finish
              setFetchFormData(formValues); // Now update the form
            };

            updateFormValues();
          }
        });
      }
    } else {
      getFormConfig();
    }
  }, [activeTab, interfaceId]);

  useEffect(() => {
    const mapFormValues = async () => {
      const formValues: Record<string, any> = {}; // Explicitly define the type

      formData?.data?.data?.forEach((section: any) => {
        section?.section[0]?.content.forEach(async (field: any) => {
          // Find the matching object in apiTwo based on placeHolderId
          const matchedEntry = fetchFormData.find(
            (entry: any) => entry.placeHolderId === field.placeHolderId
          );

          if (matchedEntry && matchedEntry.data[field.name] !== undefined) {
            const matchedValue = matchedEntry.data[field.name];

            // set form values according to it's field type
            if (field.inputType.toLowerCase() === "checkbox") {
              // Convert checkbox values to boolean
              formValues[field.name] = matchedValue === "1";
            } else if (field.inputType.toLowerCase() === "select") {
              const selectedOption = field.fieldOptions?.find(
                (option: any) =>
                  option.value.toString() === matchedValue.toString()
              );

              formValues[field.name] = selectedOption
                ? selectedOption.value.toString()
                : matchedValue.toString();
            } else if (field.inputType.toLowerCase() === "selectmulti") {
              formValues[field.name] = matchedValue
                .toString()
                .split(",")
                .map((val: any) => val.trim())
                .filter((val: string) => val !== "");
            } else if (field.inputType.toLowerCase() === "date") {
              formValues[field.name] = dayjs(matchedValue);
            } else {
              if (field.rules && field.rules[0]?.type == "number") {
                formValues[field.name] = Number(matchedValue);
              } else {
                formValues[field.name] = matchedValue;
              }
            }

            form?.setFieldValue([field.name], formValues[field.name]);
          }
        });
      });

      return formValues;
    };

    mapFormValues();
  }, [fetchFormData]);

  // Function to fetch dependent dropdown data
  const fetchDropdownData = async (
    fieldId: string,
    execParams: any[]
  ): Promise<any[]> => {
    try {
      // Transform execParams in-place
      Object.keys(execParams).forEach((key: any) => {
        if (Array.isArray(execParams[key])) {
          execParams[key] = execParams[key].join(",");
        }
      });

      const response = await API.post(getCascadeFieldOptions, {
        // method: "POST",
        // headers: { "Content-Type": "application/json" },
        FieldId: fieldId,
        FormData: JSON.stringify(execParams),
        // body: JSON.stringify({
        // }),
      });

      if (response && !response.status) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      return await response.data.data; // Parse and return the JSON response
    } catch (error) {
      console.error(`Error fetching data for ${fieldId}:`, error);
      return []; // Return an empty array in case of an error
    }
  };

  const getCascadeOptions = async (
    currentField: any,
    data: any
  ): Promise<any[]> => {
    //const currentField = fields.find((f: { name: string }) => f.name === name);//
    if (!currentField) return [];

    if (currentField.lazyload) {
      //const data = form.getFieldsValue();

      // Validate required execution parameters
      let hasError = false;
      const execParamsList = (currentField.execParams || []).reduce(
        (acc: { [x: string]: any }, param: { name: string | number }) => {
          const paramValue = data[param.name] ?? "";

          if (paramValue === "") {
            hasError = true;
            acc[param.name] = `${param.name} is required`; // Store error message
          } else {
            acc[param.name] = paramValue;
          }
          return acc;
        },
        {}
      );

      // Stop execution if validation fails and show specific error messages in dropdown
      if (hasError) {
        currentField.fieldOptions = Object.values(execParamsList)
          .filter((msg) => (msg as string).includes("is required")) // Show only required errors
          .map((msg) => ({ label: msg as string, value: "" }));

        //forceUpdate();
        return currentField.fieldOptions;
      }

      try {
        const response = await fetchDropdownData(
          currentField.Id,
          execParamsList
        );

        return response;
      } catch (error) {
        console.error(`Failed to load data for ${currentField.name}:`, error);
      }
      return [];
    }
    return [];
  };

  //Get config from backend
  const getFormConfig = async () => {
    try {
      showLoader();

      // let formTabs = await API.post(getDynamicFormTabs, {
      //   InterfaceId: interfaceId
      // });

      // console.log(formTabs);

      // let dynamicFormData;
      // if(formTabs && formTabs.data?.length > 0)
      // {
      //   dynamicFormData = formTabs;
      //   var defaultActiveTab = formTabs.data.find((x: { AdditionalDetails: { IsDefaultActiveTab: boolean; }; }) => x.AdditionalDetails?.IsDefaultActiveTab === true);
      //   if(defaultActiveTab)
      //   {
      //     setActiveTab(defaultActiveTab?.TabId.toString());
      //   }
      //   else
      //   {
      //     setActiveTab(formTabs.data[0]?.TabId.toString());
      //   }
      // }
      // else
      // {
      //   dynamicFormData = null;
      //   setActiveTab(null);
      // }

      let dynamicFormData: any;

      let formConfigResponse = await API.post(getFormConfigDetails, {
        InterfaceId: interfaceId,
        TabId: activeTab || 0,
        Mode: mode ? mode : "Create",
        FieldIds: "",
        FormData: "",
        ActionType: "",
        SearchString: "",
      });

      if (formConfigResponse.data && formConfigResponse.data.data.length > 0) {
        formConfig = formConfigResponse;

        console.log(formConfig);
        if (dynamicFormData) {
          for (let index = 0; index < dynamicFormData.data.length; index++) {
            let data = dynamicFormData.data;
            if (!dynamicFormData.data[index]) {
              dynamicFormData.data[index] = {}; // Initialize it as an empty object
            }

            dynamicFormData.data[index].section =
              formConfig.data.find(
                (x: { tabId: { toString: () => any } }) =>
                  x.tabId.toString() === data[index]?.TabId?.toString()
              )?.section || {}; // Assign a default object if no match is found
          }
        } else {
          dynamicFormData = formConfigResponse.data.data;
        }

        if (activeTab) {
          setFormSections(formConfigResponse.data.data[0].section);
        } else {
          if (formConfigResponse.data?.data[0]?.section?.length > 0) {
            setFormSections(formConfigResponse.data.data[0].section);
          } else {
            setFormSections(formConfigResponse.data.data);
          }
        }
        //console.log(dynamicFormData);
        //  setFormData(FormResponse);
        //setFormData(dynamicFormData);
        // form.setFieldsValue(formConfig);
        // let activeKeyTemp = Array.from(
        //   formConfig?.data.map((item: any) => item.key)
        // );
        //setActiveKey(activeKeyTemp);

        if (mode === "Edit") {
          debugger;
          // const FetchFormData = async () => {
          //   const FetchFormValues = await API.post(getFormValues, {
          //     InterfaceId: interfaceId,
          //     RId: RId,
          //     Mode: "Edit",
          //     ActionType: "Fetch",
          //     FieldIds: "",
          //     FormData: `{"RId":${RId}}`,
          //   });
          //   return FetchFormValues.data.data;
          // };

          let formValues = await FetchFormDataAPI();

          // const mapFormValues = (apiOne: any, apiTwo: any) => {
          //   const formValues: Record<string, any> = {}; // Explicitly define the type

          //   apiOne.forEach((section: any) => {
          //     section.section.forEach((sd: any) => {

          //       sd.content.forEach((field: any) => {
          //         // Find the matching object in apiTwo based on placeHolderId
          //         const matchedEntry = apiTwo.find(
          //           (entry: any) => entry.placeHolderId === field.placeHolderId
          //         );

          //         if (
          //           matchedEntry &&
          //           matchedEntry.data[field.name] !== undefined
          //         ) {
          //           const matchedValue = matchedEntry.data[field.name];

          //           if (field.typename === "Checkbox") {
          //             // Convert checkbox values to boolean
          //             formValues[field.name] = matchedValue === "1";
          //             // formValues[field.name] = (matchedValue?.toString() === "1").toString();
          //           } else if (field.typename === "Select") {
          //             // Map the state dropdown using label instead of value
          //             const selectedOption = field.fieldOptions?.find(
          //               (option: any) =>
          //                 option.value.toString() === matchedValue.toString()
          //             );

          //             formValues[field.name] = selectedOption
          //               ? selectedOption.value.toString()
          //               : matchedValue.toString();
          //           }  else  if (field.typename === "selectMulti"){

          //             formValues[field.name] = matchedValue
          //             .toString()
          //             .split(",")
          //             .map((val:any) => val.trim());
          //           } else {
          //             formValues[field.name] = matchedValue;
          //           }
          //         }
          //       });
          //     })
          //   });

          //   return formValues;
          // };

          // // Get mapped values
          // const mappedValues = mapFormValues(dynamicFormData, formValues);

          // // Set form fields in Ant Design
          // form.setFieldsValue(mappedValues);

          const mapFormCascadeOptions = async (apiOne: any, apiTwo: any) => {
            for (const Tab of apiOne) {
              for (const field of Tab.section[0].content) {
                // Find the matching object in apiTwo based on placeHolderId
                const matchedEntry = apiTwo.find(
                  (entry: any) => entry.placeHolderId === field.placeHolderId
                );

                if (
                  matchedEntry &&
                  matchedEntry.data[field.name] !== undefined
                ) {
                  if (field.lazyload) {
                    let fieldOptions = await getCascadeOptions(
                      field,
                      matchedEntry.data
                    );

                    if (fieldOptions.length > 0) {
                      field.fieldOptions = fieldOptions;
                    }
                  }
                }
              }
            }
          };

          const updateFormValues = async () => {
            await mapFormCascadeOptions(formConfig.data.data, formValues); // Ensure all async calls finish
            setFetchFormData(formValues); // Now update the form
          };

          updateFormValues();
        }
        setFormData(formConfig);
      }
      // }
    } catch (error) {
      hideLoader();
      console.warn(error);
    } finally {
      hideLoader();
    }
  };

  const FetchFormDataAPI = async () => {
    try {
      const FetchFormValues = await API.post(getFormValues, {
        InterfaceId: interfaceId,
        RId: RId,
        Mode: "Edit",
        ActionType: "DynamicFormActionFetch",
        FieldIds: "",
        FormData: `{"RId":${RId}}`,
      });
      return FetchFormValues.data.data;
    } catch (error) {
      console.error("Error:", error);
      return;
    }
  };

  const getKeyLength = (obj?: any, targetKey?: string): number | 0 => {
    if (!obj || typeof obj !== "object") return 0;

    if (targetKey) {
      if (targetKey in obj) {
        const value = obj[targetKey];

        if (typeof value === "string") return value.length;
        if (Array.isArray(value)) return value.length;
        if (typeof value === "object") return Object.keys(value).length;
      }

      for (const value of Object.values(obj)) {
        const length = getKeyLength(value, targetKey);
        if (length !== null) return length;
      }
    }

    return 0;
  };

  const convertMultiSelectFields = (
    obj: any,
    multiselectFields: string[]
  ): any => {
    if (Array.isArray(obj)) {
      return obj.map((item) =>
        convertMultiSelectFields(item, multiselectFields)
      );
    } else if (typeof obj === "object" && obj !== null) {
      return Object.keys(obj).reduce((acc: any, key: string) => {
        if (multiselectFields.includes(key) && obj[key]) {
          //acc[key] = obj[key].join(" ,"); // Convert array to comma-separated string

          if (typeof obj[key] === "string") {
            const valuesArray = obj[key]
              ?.split(", ") // Split the string into an array of labels
              .map((label: string) => {
                let field = findFieldByName(key);
                if (field && field.fieldOptions.length > 0) {
                  const found = field.fieldOptions?.find(
                    (opt: { label: string }) => opt.label === label
                  );
                  return found?.value || null; // Get the corresponding value or null
                }
                return null;
              })
              .filter(Boolean); // Remove null values

            acc[key] = valuesArray.join(",");
          }
        } else {
          acc[key] = convertMultiSelectFields(obj[key], multiselectFields);
        }
        return acc;
      }, {});
    }
    return obj; // Return unchanged if not an object or array
  };

  const findFieldByName = (fieldName: string) => {
    let data = formData?.data || [];
    for (const item of data) {
      if (Array.isArray(item.content)) {
        const found = item.content.find(
          (field: { name: string }) => field.name === fieldName
        );
        if (found) return found; // Return the first match found
      }
    }
    return null; // Return null if not found
  };

  //fieldset grids update function
  const handleFieldSetButtonClick = (
    action: string,
    fieldSetKey: string,
    formValue: any,
    targetIndex: number = -1
  ) => {
    let multiSelectFields: any[] = [];

    if (formData && formData.data) {
      let DataObj = formData.data;

      DataObj.forEach((element: { content: any }) => {
        console.log(element.content);
        let fields = element.content;
        fields?.forEach((f: { name: any; type: string }) => {
          if (f.type.toLowerCase() === "selectmulti") {
            multiSelectFields.push(f.name);
          }
        });
      });
    }

    if (action === "Add") {
      let fieldSetLength = getKeyLength(gridData, fieldSetKey);
      const newKey = (fieldSetLength + 1).toString();

      setGridData((prev) => ({
        ...prev,
        [fieldSetKey]: [
          ...(prev[fieldSetKey] ?? []),
          { key: newKey, ...formValue },
        ],
      }));
    } else if (action === "Update") {
      setGridData((prev) => ({
        ...prev,
        [fieldSetKey]: prev[fieldSetKey].map((item: any) =>
          item.key === targetIndex ? { ...item, ...formValue } : item
        ),
      }));
    }
  };

  const getUpdatedFormValue = (formValue: any) => {
    let multiSelectFields: any[] = [];

    if (formData && formData.data) {
      let DataObj = formData.data;

      DataObj.forEach((element: { content: any }) => {
        console.log(element.content);
        let fields = element.content;
        fields?.forEach((f: { name: any; type: string }) => {
          if (f.type.toLowerCase() === "selectmulti") {
            multiSelectFields.push(f.name);
          }
        });
      });
    }

    let UpdateFormValue = formValue;
    if (multiSelectFields?.length > 0) {
      UpdateFormValue = convertMultiSelectFields(formValue, multiSelectFields);
    }
    // multiSelectFields.every(x => {
    //   if (formValue.hasOwnProperty(x)) {
    //     let newValue = formValue[x].join(',');
    //     formValue[x] = newValue;
    //   }
    // })

    return UpdateFormValue;
  };

  const functionMapping = {
    skipAction: () => {
      message.success("Executing the skip action...");
    },

    saveAndNextAction: () => {
      message.success("Executing save and next action...");
    },
  };

  const handleInterfaceActionClick = async (form: any, button: any) => {
    setButtonLoadings((prev) => ({ ...prev, [button.label]: true }));
    try {
      // if action object is empty for buttons
      if (
        (!button?.actions || button?.actions?.length === 0) &&
        button?.actionKey?.toLowerCase() !== "dynamicformactioncancel"
      ) {
        console.error(`No action found for this ${button.label} button`);
        return;
      }

      let formValue = { ...form?.getFieldsValue(), CreatedBy: 1, ...gridData };

      if (formValue) {
        Object.keys(formValue).forEach((key) => {
          if (Array.isArray(formValue[key])) {
            formValue[key] = formValue[key].join(",");
          } else if (formValue[key] && formValue[key].$d) {
            //This is done as we want IST timezone
            formValue[key] = dayjs(formValue[key]).format(
              "YYYY-MM-DD HH:mm:ss"
            );
            formValue[key] = dayjs(formValue[key]).format(
              "YYYY-MM-DD HH:mm:ss"
            );
          }
        });
      }

      if (button?.actionKey.toLowerCase() === "dynamicformactionreset") {
        form.resetFields();
        setIsReset(true);
        //clearing rowForm Data:
       // message.info("Form reset successfully.");

        return;
      } else if (
        button?.actionKey.toLowerCase() === "dynamicformactioncancel"
      ) {
        /* ***********************   CANCEL *********************** */
        // dynamic navigation is pending on the cancel button
        form?.resetFields();
        props.handleCancel?.();
        return;
      } else if (button?.actionKey.toLowerCase() == "skip") {
        /* ***********************   SKIP *********************** */
        functionMapping["skipAction"]();
      } else if (button?.actionKey.toLowerCase() == "save") {
        functionMapping["saveAndNextAction"]();
      } else if (
        button?.actionKey.toLowerCase() === "dynamicformactionupdate"
      ) {
        await form?.validateFields();

        let formValue = { ...form?.getFieldsValue(), CreatedBy: 1, RId: RId };

        if (formValue) {
          Object.keys(formValue).forEach((key) => {
            if (Array.isArray(formValue[key])) {
              formValue[key] = formValue[key].join(",");
            } else if (formValue[key] && formValue[key].$d) {
              //This is done as we want IST timezone
              formValue[key] = dayjs(formValue[key]).format(
                "YYYY-MM-DD HH:mm:ss"
              );
              formValue[key] = dayjs(formValue[key]).format(
                "YYYY-MM-DD HH:mm:ss"
              );
            }
          });
        }

        for (const action of button.actions) {
          const { execType, execData } = action;
          let result;
          if (execType === "Function") {
            if (!interfaceActionHandler[execData]) {
              console.error(`No handler found for function: ${button.label}`);
              return;
            }
            result = await interfaceActionHandler[execData](
              button.actionKey,
              button
            );
          } else if (execType === "Query" || execType === "SP") {
            const getFormData = await API.post(getFormValues, {
              InterfaceId: interfaceId,
              RId: RId,
              Mode: "Edit",
              ActionType: "DynamicFormActionUpdate",
              ActionId: action.actionId,
              FieldIds: "",
              FormData: JSON.stringify(formValue),
            });

            if (getFormData.data.status != 0) {
                console.log('ExecuteActionResponse.data=>', getFormData.data);
                if(getFormData.data && 
                  getFormData.data?.errorCode && 
                  getFormData.data?.errorCode == 'DB_VALIDATION')
                  {
                    message.error(getFormData.data.message);    
                    return;
                  }
                  else
                  {
                    console.log('ExecuteActionResponse.data.errorCode=>', getFormData.data.errorCode);
                    //message.error(`Failed.`);
                    message.error("Something went wrong. ")
                  }
              
            } else {
              message.success("Updated successfully.");
              form?.resetFields();
              props.handleCancel?.();
            }
          } else {
            console.error(`Unsupported execType: ${execData}`);
            return;
          }
          if (!result) {
            // message.error(
            //   `Handler for "${button.label}" executed but returned no result.`
            // );
            console.error(
              `Handler for "${button.label}" executed but returned no result.`
            );
          } else {
            // message.success(
            //   `Handler for "${button.label}" executed successfully: ${result}`
            // );
            console.error(
              `Handler for "${button.label}" executed successfully: ${result}`
            );
          }
        }
      } else {
        await form?.validateFields();
        /* *********************** SUBMIT(CREATE) / OTHER *********************** */
        for (const action of button.actions) {
          const { execType, execData } = action;
          let result;
          if (execType === "Function") {
            if (!interfaceActionHandler[execData]) {
              console.error(`No handler found for function: ${button.label}`);
              return;
            }
            result = await interfaceActionHandler[execData](
              button.actionType,
              formValue
            );
          } else if (execType === "Query" || execType === "SP") {
            let ExecuteActionResponse = await API.post(executeAction, {
              InterfaceId: interfaceId,
              ActionType: button?.actionKey,
              ActionId: action.actionId,
              Mode: "Create",
              // FormData: JSON.stringify(UpdateFormValue),
              FormData: JSON.stringify(formValue),
              FieldIds: "",
              SearchString: "",
            });

              if (ExecuteActionResponse.data.status != 0) {
                console.log('ExecuteActionResponse.data=>', ExecuteActionResponse.data);
                if(ExecuteActionResponse.data && 
                  ExecuteActionResponse.data?.errorCode && 
                  ExecuteActionResponse.data?.errorCode == 'DB_VALIDATION')
                  {
                    message.error(ExecuteActionResponse.data.message);    
                    return;
                  }
                  else
                  {
                    console.log('ExecuteActionResponse.data.errorCode=>', ExecuteActionResponse.data.errorCode);
                    //message.error(`Failed.`);
                    message.error("Something went wrong. ")
                  }
              } else {
                message.success("Data Created Successfully.");
                form?.resetFields();
                props.handleCancel?.();
              }
            } else {
              console.error(`Unsupported execType: ${execData}`);
              return;
            }
            if (!result) {
              // message.error(
              //   `Handler for "${button.label}" executed but returned no result.`
              // );
              console.error(`Handler for "${button.label}" executed but returned no result.`);
              
            } else {
              // message.success(
              //   `Handler for "${button.label}" executed successfully: ${result}`
              // );
              console.error(`Handler for "${button.label}" executed successfully: ${result}`);
            }
          }
          
        } 
        
      } catch (error) {
        console.error(`No action found for this ${button.label}:`, error);
        //message.error(`No action found for this ${button.label}`);
      } finally {
        setButtonLoadings((prev) => ({ ...prev, [button.label]: false }));
      }
    };

  const handleButtonClick = async (form: any, buttonConfig: any) => {
    try {
      // enterButtonLoading(buttonConfig);

      setButtonLoadings((prev) => ({ ...prev, [buttonConfig]: true }));

      showLoader();
      // event.preventDefault();
      /* ***********************   SUBMIT *********************** */

      let formValue = {
        ...form.getFieldsValue(),
        CreatedBy: userId,
        ...gridData,
      };

      if (formValue) {
        Object.keys(formValue).forEach((key) => {
          if (Array.isArray(formValue[key])) {
            formValue[key] = formValue[key].join(",");
          }
        });
      }

      if (buttonConfig === "dynamicformactionsubmit") {
        await form?.validateFields();
        let ExecuteActionResponse = await API.post(executeAction, {
          InterfaceId: interfaceId,
          ActionType: buttonConfig,
          Mode: "Create",
          FormData: JSON.stringify(formValue),
          FieldIds: "",
          SearchString: "",
        });

        if (ExecuteActionResponse.data.status != 0) {
          message.error(`Failed.`);
        } else {
          message.success("Data Created Successfully.");
          form?.resetFields();
          props.handleCancel?.();
        }
      }

      /* ***********************   Update *********************** */

      if (buttonConfig === "dynamicformactionupdate") {
        let formValue = {
          ...form?.getFieldsValue(),
          CreatedBy: userId,
          RId: RId,
        };
        if (formValue) {
          Object.keys(formValue).forEach((key) => {
            if (Array.isArray(formValue[key])) {
              formValue[key] = formValue[key].join(",");
            }
          });
        }

        await form?.validateFields();
        const getFormData = await API.post(getFormValues, {
          InterfaceId: interfaceId,
          RId: RId,
          Mode: "Edit",
          ActionType: "DynamicFormActionUpdate",
          FieldIds: "",
          FormData: JSON.stringify(formValue),
        });
        if (getFormData.data.status != 0) {
          message.error(`Failed.`);
        } else {
          message.success("Updated successfully.");
          form?.resetFields();
          props.handleCancel?.();
        }
      }

      /* ***********************   RESET *********************** */

      if (buttonConfig === "dynamicformactionreset") {
        form.resetFields();
        setIsReset(true);
        //clearing rowForm Data:
       // message.info("Form reset successfully.");

        return;
      }

      /* ***********************   CANCEL *********************** */
      // dynamic navigation is pending on the cancel button
      if (buttonConfig === "dynamicformactioncancel") {
        form?.resetFields();
        props.handleCancel?.();
        return;
      }

      /* ***********************   SKIP *********************** */
      // dynamic navigation is pending on the skip button
      if (buttonConfig.toLowerCase() == "skip") {
        functionMapping["skipAction"]();
      }
      if (buttonConfig.toLowerCase() == "save") {
        functionMapping["saveAndNextAction"]();
      }
    } catch (error) {
      hideLoader();
      console.error("Error:", error);
      message.error(`Failed to perform ${buttonConfig.label}`);
    } finally {
      hideLoader();
      setButtonLoadings((prev) => ({ ...prev, [buttonConfig]: false }));
    }
  };

  const checkButtonIsLoading = (type: string) => {
    return buttonLoadings[type];
  };

  return (
    <div className="container-fluid">
      <div className="col-lg-12 ">
        <div className="pageName">
          <Title level={4}>
            {(formSections && formSections[0]?.interfaceName) || ""}
          </Title>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 ">
          <div className="form-container m-0">
            {" "}
            {formSections?.length > 0 ? (
              formSections?.map((section: any) =>
                section?.header === "ActionConfig" ? (
                  <>
                    <div className="button-section" key={section.key}>
                      {section?.content?.map((field: any) => (
                        <>
                          <DynamicFormCase
                            field={field}
                            form={form}
                            keyIdentity={section.key}
                            handleButtonClick={handleInterfaceActionClick}
                            actionType={actionType}
                            fields={[]}
                            dataSource={[]}
                            colsize={undefined}
                            checkButtonIsLoading={checkButtonIsLoading}
                          />
                        </>
                      ))}
                    </div>
                  </>
                ) : (
                  <>
                    {section.header != null && section.header != "" ? (
                      <>
                        <Collapse
                          defaultActiveKey={section.key}
                          key={section.key}
                          className="Collapse-container my-3 mx-0"
                        >
                          <Panel header={section.header} key={section.key}>
                            <Row gutter={[8, 8]} key={section.key}>
                              {section?.content?.map((field: any) => (
                                <>
                                  {field.parentId == 0 && (
                                    <>
                                      <DynamicFormCase
                                        field={field}
                                        fields={section.content}
                                        form={form}
                                        keyIdentity={section.key}
                                        handleButtonClick={
                                          handleInterfaceActionClick
                                        }
                                        actionType={actionType}
                                        dataSource={gridData[field.name]}
                                        handleFieldSetButtonClick={
                                          handleFieldSetButtonClick
                                        }
                                        colsize={undefined}
                                        checkButtonIsLoading={
                                          checkButtonIsLoading
                                        }
                                      />
                                    </>
                                  )}
                                </>
                              ))}
                            </Row>
                          </Panel>
                        </Collapse>
                      </>
                    ) : (
                      <>
                        <Row gutter={[8, 8]} key={section.key}>
                          {section?.content?.map((field: any) => (
                            <>
                              {/* fields with no parent Id will only get passed from here */}
                              {(field.parentId === 0 ||
                                (field.parentId !== 0 &&
                                  field.inputType !== "fieldset")) && (
                                <>
                                  <DynamicFormCase
                                    field={field}
                                    fields={section.content}
                                    form={form}
                                    keyIdentity={section.key}
                                    handleButtonClick={
                                      handleInterfaceActionClick
                                    }
                                    actionType={actionType}
                                    dataSource={gridData[field.name]}
                                    handleFieldSetButtonClick={
                                      handleFieldSetButtonClick
                                    }
                                    colsize={undefined}
                                    checkButtonIsLoading={checkButtonIsLoading}
                                  />
                                </>
                              )}
                            </>
                          ))}
                        </Row>
                      </>
                    )}
                  </>
                )
              )
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DynamicFormComponent;
